import React, { useContext, useEffect, useRef } from "react";
import { MainContext } from "../../MainContext";

type ModalProps = {
	image: string;
	title: string;
	subTitle: string;
	text: string;
	type?: string;
};

const contacts = {
	number: "+374-77-03-1191",
	email: "mesropian.ling.center@gmail.com",
	insta_link: "https://www.instagram.com/mesropian_linguistic_center?igsh=MWh4cWo0anZwYzZybg%3D%3D",
	facebook_link: "https://www.facebook.com/people/Mesropian-Linguistic-Center/61570859967241/?mibextid=wwXIfr&rdid=928BqfAMdz7Digud&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1ARXepxgPE%2F%3Fmibextid%3DwwXIfr"
}

//@ts-ignore
const Modal: React.FC<ModalProps> = ({ image, title, subTitle, text, type }) => {
	const { closeModal } = useContext(MainContext);
	const whiteRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			//@ts-ignore
			if (whiteRef.current && !whiteRef.current.contains(event.target)) {
				closeModal();
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [closeModal]);


	return (
		<div className="modal">
			{type === "contact" ? (
				<div className={`white ${type === "contact" ? "contact" : ""}`} ref={whiteRef}>
				<div className="img" style={{ backgroundImage: `url('/logo-white.png')` }}></div>
				<div className="texts">
					<p>📞 Phone: {contacts.number}</p>
					<p>📧 Email: {contacts.email}</p>
					<a href={contacts.insta_link} target="_blank"><img src="/insta.png" alt="" /></a>
					<a href={contacts.facebook_link} target="_blank"><img src="/face.png" alt="" /></a>
				</div>
			</div>
			) : (
				<div className={`white ${type === "contact" ? "contact" : ""}`} ref={whiteRef}>
					<div className="img" style={{ backgroundImage: `url(${image})` }}></div>
					<div className="texts">
						<h1>{title}</h1>
						<h4>{subTitle}</h4>
						<hr />
						<p>{text}</p>
					</div>
				</div>
			)}
		</div>
	);
};

export default Modal;
